<template>
    <div class="row">
        <div class="col-lg-6">
            <div v-if="currentExperiment.id">
                Aktualnie trwa eksperyment: {{currentExperiment.name}} (od {{currentExperiment.startDate}})
                <button class="btn btn-confirm" @click.prevent="terminate()">Zakończ</button>
            </div>
            <div v-if="!currentExperiment.id">

                Wybierz eksperyment cenowy:
                <br/>

                <select id="select2" v-model="selectedExperimentId" class="form-control" required>
                    <option v-for="experiment in experiments" :value="experiment.id">{{experiment.name}}</option>
                </select>

                <button class="btn btn-confirm" @click.prevent="save()">Rozpocznij eksperyment</button>
            </div>
        </div>
        <div class="col-lg-6">
            <table class="table table-bordered table-condensed">
                <thead>
                <tr>
                    <th>Dzień</th>
                    <th>Reguła</th>
                    <th>Kupno</th>
                    <th>Cena reguły</th>
                    <th>Stan magazynowy</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(value, key, index) in results">
                    <td>{{key}}</td>
                    <td>{{ruleName(value.rule, index)}}</td>
                    <td>{{value.purchase_price | numberOrDash}}</td>
                    <td>{{value.proposed_price | numberOrDash}}</td>
                    <td>{{value.in_stock | numberOrDash}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

    import {experiments, product} from '../../services'

    export default {
//        props: ['id'],
        data() {
            return {
                experiments: [],
                currentExperiment: {
                    id: 0,
                    name: '',
                    startDate: ''
                },
                results: [],
                selectedExperimentId: 0,
                baseRuleNameId: 0
            }
        },
        mounted() {
            experiments.getProductExperimentData(this, this.id, response => {
                this.experiments = response.body.experiments;
                this.currentExperiment = response.body.currentExperiment;
                this.results = response.body.results;
            })
        },
        methods: {
            ruleName(id, index) {
                if (index == 0) {
                    this.baseRuleNameId = id
                }
                return this.baseRuleNameId == id ? 'bazowa' : 'testowa';
            },
            save() {
                const productData = {
                    price_experiment_id: this.selectedExperimentId
                }
                product.saveExperiment(this, productData, this.id, response => {
                    this.currentExperiment.id = this.selectedExperimentId;
                    this.currentExperiment.startDate = 'teraz';
                    for (const i in this.experiments) {
                        if (this.experiments.hasOwnProperty(i) && this.experiments[i].id == this.selectedExperimentId) {
                            this.currentExperiment.name = this.experiments[i].name;
                        }
                    }
                })
            },
            terminate() {
                const productData = {
                    price_experiment_id: 0
                }
                product.saveExperiment(this, productData, this.id, response => {
                    this.currentExperiment.id = 0;
                })
            }
        }
    }

</script>



// WEBPACK FOOTER //
// PriceExperiment.vue?e25fb20e